<template>
  <div class="main">
    <div class="back" @click="router.push('/enterpriseManage/enterprise')"> <a-button type="primary"><i
        class="iconfont icon-fanhuiicon mr5"></i> 返回</a-button></div>
    <div>

    </div>
    <div class="query-item">
      <div class="search-l">
        <div>
          企业名称
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.name"></a-input>
        </div>
        <div class="ml30">
          法人名称
          <a-input class="inp ml24" placeholder="请输入" v-model:value="query.corporationName"></a-input>
        </div>
        <a-button class="ml30" @click="search" type="primary" ghost>查询</a-button>
        <a-button class="ml24" @click="reset" type="primary" ghost>重置</a-button>
        <div></div>
      </div>
      <div class="search-r">
      </div>
    </div>
    <a-table :columns="columns" :row-key="(record) => record.id" :data-source="dataSource" class="mt23" size="middle"
             :pagination="pagination" :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
          }" :scroll="{ y: 'auto' }" v-autoHeight="{ extraHeight: 88, trHeight: 47 }">
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'ranking'">
          {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
        </template>
        <template v-if="column.key === 'createTime'">
          {{ moment(record.createTime).format("YYYY-MM-DD HH:mm:ss") }}
        </template>
        <template v-if="column.key === 'status'">
          <a-tag v-if="record.reviewStatus === 0" color="warning">待审核</a-tag>
          <a-tag v-if="record.reviewStatus === -1"  color="warning">审核未通过</a-tag>
        </template>
        <template v-else-if="column.key === 'action'">
          <span v-if="record.reviewStatus === 0 && store.hasPermi('enterprise:review')">
            <a @click="toReview(record)">审核</a>
          </span>
        </template>
      </template>
    </a-table>
    <Drawer ref="DrawerVal" :drawerTitle="drawerTitle" @drawerEvent="reviewEvent"></Drawer>
  </div>
</template>
<script setup>
import { ref, onMounted, reactive } from "vue";
import { useRouter } from "vue-router";

import moment from "moment";
import Drawer from '@/views/enterprise/drawer.vue'
import { message } from 'ant-design-vue'
import {getList, review} from '@/api/enterprise/index.js'

import useUserStore from '@/store/modules/user'

const store = useUserStore()

const router = useRouter();

const columns = [
  {
    title: "序号",
    key: "ranking",
    width: 90
  },
  {
    title: "企业名称",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "统一信用代码",
    dataIndex: "unifyCode",
    key: "unifyCode",
    width: 200,
  },
  {
    title: "法人姓名",
    key: "corporationName",
    dataIndex: "corporationName",
    // width: 100,
  },
  {
    title: "联系人姓名",
    key: "linkName",
    dataIndex: "linkName",
  },
  {
    title: "联系人电话",
    key: "linkPhone",
    dataIndex: "linkPhone",
  },
  {
    title: "公司地址",
    key: "address",
    dataIndex: "address",
    width:320
  },
  {
    title: "状态",
    key: "status",
  },
  {
    title: "申请时间",
    key: "createTime",
    dataIndex: "createTime",
  },
  {
    title: "操作",
    key: "action",
  },
];

let dataSource = ref([]);
let query = reactive({
  name: "",
  corporationName: "",
  reviewStatus: 0
});

const pagination = reactive({
  total: 0,
  size: "middle",
  defaultPageSize: 10,
  current: 1,
  pageSize: 10, //每页中显示10条数据
  showSizeChanger: true,
  showQuickJumper: false,
  pageSizeOptions: ["10", "20", "30"], //每页中显示的数据
  showTotal: (total) => `共有 ${total} 条数据`, //分页中显示总的数据
  onShowSizeChange: (current, pageSize) => (pagination.pageSize = pageSize), // 改变每页数量时更新显示
  onChange: pageChange, //点击页码事件
  showSizeChange: pageSizeChange,
});


const drawerTitle = ref('')

function pageChange(page, pageSize) {
  pagination.current = page;

  // 获取表格数据
  getData();
}

function pageSizeChange(current, size) {
  console.log(size);
  pagination.pageSize = size;

  // 获取表格数据
  getData();
}

const search = () => {
  pagination.current = 1;
  getData();
};

const reset = () => {
  query.corporationName = "";
  query.name = "";
  pagination.current = 1;
  getData();
};

const getData = () => {
  const data = {
    pageIndex: pagination.current,
    pageSize: pagination.pageSize,
    conditionMap: { ...query,id: store.deptId },
  };
  getList(data).then((res) => {
    console.log(res);
    dataSource.value = res.data.records || [];
    pagination.total = res.data.total;
  });
};

onMounted(async () => {
  await getData();
});


const DrawerVal = ref(null)

const reviewEvent = (info) => {
  if (drawerTitle.value === '审核') {
    console.log('审核', info);
    review(info).then(res => {
      if (res.code === 200) {
        message.success('提交成功')
        getData()
      }
    })
  }
}

const toReview = (record) => {
  drawerTitle.value = '审核'
  DrawerVal.value.showDrawer(record)
}

// 多选数据
const selectedRowKeys = ref([]);

const onSelectChange = (value) => {
  console.log("selectedRowKeys changed: ", value);
  selectedRowKeys.value = value;
};

</script>

<style lang="less" scoped>

.pending-btn {
  position: relative; /* 确保徽标相对于按钮定位 */
  padding-right: 12px; /* 给徽标留出空间，避免文字被遮挡 */
}

.badge {
  position: absolute;
  top: -6px;       /* 向上微调，使其贴近按钮边缘 */
  right: -6px;     /* 向右微调，使其贴近按钮边缘 */
  background: #ff4d4f; /* 红色背景 */
  color: white;
  border-radius: 10px; /* 圆形效果 */
  min-width: 18px;    /* 最小宽度 */
  height: 18px;       /* 高度 */
  line-height: 18px;  /* 垂直居中 */
  text-align: center; /* 水平居中 */
  font-size: 12px;
  font-weight: bold;
  padding: 0 4px;     /* 左右内边距，避免数字太小时显示不全 */
  box-shadow: 0 0 0 1px #fff; /* 可选：白色边框，增强对比度 */
}

.inp {
  width: 13.5vw;
}

.query-item {
  display: flex;
  justify-content: space-between;

  .search-l {
    display: flex;
  }

  .search-r {
    display: flex;
  }
}

/deep/.ant-input::placeholder {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #68767e;
}

/deep/.ant-select-selector {
  background-color: #f2f4f7 !important;
  color: #68767e !important;
}

.main {
  padding: 20px;
  height: calc(100vh - 70px - 57px);
  background-color: #ffffff;

  .back {
    position: fixed;
    top: 93px;
    right: 50px
  }
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th,
.ant-table-wrapper .ant-table-thead>tr>td {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(10, 33, 46, 1);
  background-color: rgba(239, 240, 245, 1);
}

/deep/.ant-table-wrapper .ant-table:not(.ant-table-bordered) .ant-table-tbody>tr {
  color: rgba(104, 118, 126, 1);
}

/deep/ .ant-table-wrapper .ant-table-thead>tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
.ant-table-wrapper .ant-table-thead>tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  width: 0px;
}

a {
  color: #1E8EF2;
}
</style>